<template>
  <div>
    <p>
      {{
        ft(
          featureName,
          'reportingChannels.physicalMeeting.confirmDescription',
          $t,
          {
            organizationTitle: organizationFullName,
            email
          }
        )
      }}
    </p>
  </div>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'PhysicalMeetingConfirm',
  extends: LocalizableComponent,
  props: {
    email: {
      type: String,
      required: true,
      default: null
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    featureName: {
      type: String,
      default: ''
    }
  }
}
</script>
<style></style>
